<!-- ***************************************
TEMPLATE: Side nav
*************************************** -->
<!-- <p>side-nav-controls works!</p> -->
<nb-menu [items]="sideNavControls">
</nb-menu>